import Option from "@p-ban/common/src/components/form/SelectBox/Option"
import Select from "@p-ban/common/src/components/form/SelectBox/Select"
import { removeWhiteSpaceCharacter } from "@p-ban/common/src/utils/StringUtils"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./fpcSurfacePutData.png"

const FPC面付けされたデータ = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { fpcSurfacePutData: shouldShow } = getDisplayCondition(values)

  const legend = "FPC面付けされた\nデータ"

  return (
    <OneClickField isShow={shouldShow} legend={legend} helpURL={HELP_LINKS.FPC面付けされたデータ} src={img}>
      <OneClickFieldStack>
        <Select
          name={FIELD_NAMES.FPC面付けされたデータ}
          value={values.fpcSurfacePutData}
          onChange={handlers.select}
          aria-label={removeWhiteSpaceCharacter(legend)}
        >
          {Object.values(ESTIMATE_CONSTANT.FPC面付けされたデータ).map(({ name, value }) => (
            <Option key={value} value={value}>
              {name}
            </Option>
          ))}
        </Select>
      </OneClickFieldStack>
      <OneClickFieldMessages error={errors?.fpcSurfacePutData} />
    </OneClickField>
  )
}

export default FPC面付けされたデータ
